<div class="d-flex justify-content-between align-items-center">
  <div class="d-flex align-items-center gap-3 w-100">
    <div class="flex-fill"></div>
  </div>
</div>

<div class="filters-box">
  <mat-form-field2
    class="field-categories"
    [showLabel]="false"
    i18n-matTooltip
    matTooltip="Filter the below rates by category."
    matTooltipPosition="above"
  >
    <mat-select [formControl]="categoryControl" i18n-placeholder placeholder="Category">
      <mat-option value="*" i18n>All categories</mat-option>
      <mat-option *ngFor="let category of categories$ | async" [value]="category">{{ category }}</mat-option>
    </mat-select>
  </mat-form-field2>

  <mat-form-field2
    class="field-types"
    [showLabel]="false"
    i18n-matTooltip
    matTooltip="Filter the below rates by type."
    matTooltipPosition="below"
  >
    <mat-select [formControl]="typeControl" placeholder="Type">
      <mat-option value="*" i18n>All types</mat-option>
      <mat-option *ngFor="let type of rateTypes" [value]="type.value">{{ type.label }}</mat-option>
    </mat-select>
  </mat-form-field2>

  <mat-form-field2
    class="field-period"
    [showLabel]="false"
    i18n-matTooltip
    matTooltip="Filter the below rates by period."
    matTooltipPosition="above"
  >
    <app-mat-daterange-input
      i18n-placeholder
      placeholder="Rate Period"
      [formControl]="periodControl"
    ></app-mat-daterange-input>
  </mat-form-field2>

  <app-select-search
    [inline]="true"
    bindValue="id"
    bindLabel="name"
    [items]="filteredRentals$ | async"
    [ctrl]="rentalsControl"
    i18n-matTooltip
    i18n-placeholder
    placeholder="Rentals"
    matTooltip="Filter the below rates by rentals."
    matTooltipPosition="above"
  >
  </app-select-search>

  <app-cancel-filters [isFiltering]="isFiltering" (clear)="clearFilters()"></app-cancel-filters>

  <app-button
    (click)="onRefresh()"
    icon="far fa-sync"
    class="btn btn-secondary-primary"
    i18n-matTooltip
    [loading]="isRefreshing$ | async"
    matTooltip="Refresh"
    matTooltipPosition="above"
  >
  </app-button>

  <div class="flex-fill"></div>
  <div class="text-black-50">
    <div *ngIf="isAnySelected()">{{ getSelected().length }} <ng-container i18n>items are selected.</ng-container></div>
  </div>
  <div class="flex-fill"></div>

  <app-table-search
    [ctrl]="searchControl"
    #search
    i18n-matTooltip
    matTooltip="Search by name or category"
    matTooltipPosition="above"
  ></app-table-search>
  <button
    type="button"
    class="btn btn-secondary-danger"
    [disabled]="!isAnySelected() || isDeleting || !groupRatesLoaded || (1 | isReadonlyRole)"
    (click)="onDelete()"
    [matTooltip]="selectRatesTooltip"
  >
    <i class=" {{ isDeleting ? 'far fa-spinner fa-spin' : 'cs-icon cs-icon-trash' }}"></i>
    <ng-container *ngIf="isAllSelected(false)"> <ng-container i18n>Delete All Rates</ng-container> </ng-container>
    <ng-container *ngIf="!isAllSelected(false)"><ng-container i18n>Delete</ng-container></ng-container>
  </button>

  <div class="btn-group" dropdown [isDisabled]="1 | isReadonlyRole">
    <button type="button" class="btn btn-secondary-info dropdown-toggle" dropdownToggle>
      <span class="fas fa-hands-usd"></span> <ng-container i18n>Add Group Rates</ng-container>
    </button>
    <ul class="dropdown-menu dropdown-menu-right" *dropdownMenu>
      <li>
        <button
          type="button"
          (click)="onAddStandardRate()"
          i18n-matTooltip
          matTooltip="Standard rates are flat, constant rates which do not change over time."
          matTooltipPosition="left"
        >
          <i class="fas fa-hands-usd"></i> <ng-container i18n>Add Standard Group Rate</ng-container>
        </button>
      </li>
      <li>
        <button
          type="button"
          (click)="onAddDynamicRate()"
          i18n-matTooltip
          matTooltip="Dynamic rates will gradually and automatically adjust from a low rate to a high rate as your overall rental occupancy level changes. They can also instantly update your channels as the rate changes."
          matTooltipPosition="left"
        >
          <i class="fas fa-hands-usd"></i> <ng-container i18n>Add Dynamic Group Rate</ng-container>
        </button>
      </li>
    </ul>
  </div>
</div>

<div class="table-holder table-responsive">
  <table class="table table-default table-striped">
    <mat-table #table matSort matSortActive="period" matSortDirection="asc" [dataSource]="dataSource">
      <ng-container matColumnDef="select">
        <mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            [checked]="selection.hasValue() && isAllSelected(isSelectAllRenderedItems)"
            [indeterminate]="selection.hasValue() && !isAllSelected(isSelectAllRenderedItems)"
            (change)="onMasterToggle($event?.checked)"
            class="master-toggle"
            matTooltip="Select all rates"
          >
          </mat-checkbox>
          <div class="btn-group master-toggle-group" dropdown container="body" [isDisabled]="!dataSource.data?.length">
            <div dropdownToggle>
              <i class="fa fa-caret-down ml-2"></i>
            </div>
            <ul class="dropdown-menu" *dropdownMenu>
              <li>
                <button type="button" (click)="onSelectAll(true)" i18n>All</button>
              </li>
              <li>
                <button type="button" (click)="onSelectAll(false)" i18n>All Visible</button>
              </li>
              <li>
                <button type="button" (click)="onMasterToggle(false)" i18n>None</button>
              </li>
            </ul>
          </div>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)"
          >
          </mat-checkbox>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Name</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.name }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="category">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          <span
            i18n-matTooltip
            matTooltip="Rate categories are used to group multiple rates together. Rates in a Rate Category cannot overlap. When updating a channel you push a single rate category. All rates in that category will be pushed to the channel."
            matTooltipPosition="above"
          >
            <ng-container i18n>Category</ng-container> <i class="fas fa-info-circle"></i>
          </span>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ getRateCategory | call : element }}
          <b *ngIf="element.type === 'dynamic'" matTooltip="Dynamic Rate" matTooltipPosition="right">(D)</b>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="rentals">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Rentals</mat-header-cell>
        <mat-cell
          *matCellDef="let element"
          [matTooltip]="getRentalsTooltip | call : element.rentalIds"
          matTooltipPosition="above"
        >
          {{ element.rentalIds.length }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="period">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Rate Period</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.start | epochUTC : 'MMM D, YYYY' }} - {{ element.end | epochUTC : 'MMM D, YYYY' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="nightly">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Nightly</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div
            class="text-truncate"
            [matTooltip]="
              element.type === 'dynamic'
                ? (element.lowRate | rate : currency : false) + ' - ' + (element.highRate | rate : currency : false)
                : element.nightly
                ? (element.nightly | rate : currency : false)
                : '...'
            "
          >
            <ng-template [ngTemplateOutlet]="element.type === 'dynamic' ? range : nightly"></ng-template>

            <ng-template #range>
              {{ element.lowRate | rate : currency : false }} -
              {{ element.highRate | rate : currency : false }}
            </ng-template>
            <ng-template #nightly>
              {{ element.nightly ? (element.nightly | rate : currency : false) : '...' }}
            </ng-template>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="weekly">
        <mat-header-cell *matHeaderCellDef mat-sort-header Category>Weekly</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.weekly ? (element.weekly | rate : currency : false) : '...' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="monthly">
        <mat-header-cell *matHeaderCellDef mat-sort-header Category>Monthly</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.monthly ? (element.monthly | rate : currency : false) : '...' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="minimumStay">
        <mat-header-cell *matHeaderCellDef mat-sort-header Category>Min Stay</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.minimumStay }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="touch">
        <mat-header-cell *matHeaderCellDef mat-sort-header><ng-container i18n>Updated</ng-container></mat-header-cell>
        <mat-cell *matCellDef="let element" [matTooltip]="element.touch | epoch : 'datetime'">
          {{ element.touch | epoch : 'date' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="edit">
        <mat-header-cell *matHeaderCellDef Category> EDIT</mat-header-cell>

        <mat-cell *matCellDef="let element">
          <div dropdown placement="bottom right" container="body" [isDisabled]="1 | isReadonlyRole">
            <div dropdownToggle (click)="$event.stopPropagation()" class="btn-group btn-ellips-holder">
              <a class="btn-ellips">
                <i class="fas fa-ellipsis-v"></i>
              </a>
            </div>
            <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
              <li>
                <button
                  (click)="onEdit(element)"
                  type="button"
                  i18n-matTooltip
                  matTooltip="Edit this rate"
                  matTooltipPosition="left"
                >
                  <i class="fal fa-edit"></i> Edit
                </button>
              </li>
              <li>
                <button
                  (click)="onDelete(element)"
                  type="button"
                  [disabled]="!groupRatesLoaded"
                  matTooltip="Remove this rate"
                  i18n-matTooltip
                  matTooltipPosition="left"
                >
                  <i class="cs-icon cs-icon-trash"></i> <ng-container i18n>Delete</ng-container>
                </button>
              </li>
            </ul>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns" (click)="onEdit(row)" class="clickable"> </mat-row>
    </mat-table>

    <mat-paginator2
      #paginator
      [length]="dataSource?.data?.length"
      [class.hidden]="isEmptyTable$ | async"
      (page)="onPageChange($event)"
      [pageSize]="savedPageSize"
      [pageSizeOptions]="[5, 10, 20, 50, 75, 100]"
      [showFirstLastButtons]="true"
    >
    </mat-paginator2>

    <app-empty-table *ngIf="isEmptyTable$ | async" [type]="tableType" class="bg-white"></app-empty-table>
  </table>
</div>
